// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import DealerItem from './dealer-item';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateRequestCount from '@deere/cps-it.warranty-model-factory/lib/labor-rate-request-count';
import LaborRateRequestTypeCount from './labor-rate-request-count';
import {Link} from 'react-router';
import RefinableListWidget from '../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../shared/state/search-filters';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {create as createHashMap} from '../../../shared/services/hashmap';
import {getToggleLabel} from '../../../user/shared/services/user-settings-helpers';
import sortOptions from '../constants/sort-options';

function handleFilterByChange(filterBy) {

    this.actions.updateListFilterBy(this.dealers, filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateListSortBy(this.dealers, sortBy, this.searchFilters.sortDirection);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateListSortDirection(this.dealers, this.searchFilters.sortBy, sortDirection);

}

class LaborRateDealersList extends Component {

    componentWillMount() {

        if (this.props.queryParams && this.props.queryParams.submitted) {

            this.props.actions.resetSelectedDealer();

        }

        this.props.actions.readDealers(this.props.searchFilters);
        this.props.actions.readLaborRateCount();

    }

    handleToggleAll() {

        const selectedDealer = this.props.dealersFiltered.filter(dealer =>

            dealer.requestStatus.key !== 'NEW'

        );

        this.props.actions.toggleAllAccounts(selectedDealer);

    }

    handleDealerChange(dealer, account, isSelected) {

        this.props.actions.updateDealerLaborRateAccounts(dealer, isSelected);

    }
    render() {

        const dealerList = this.props.dealersFiltered.map(dealer =>
            <DealerItem
                dealer={dealer}
                handleDealerChange={this.handleDealerChange.bind(this, dealer)}
                initialState={createHashMap(this.props.selectedDealers, 'account')}
                key={dealer.account}
                uid='account'
            />
        );

        return (
            <section>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='cancel-or-update-button'>
                    {
                            this.props.dealersFiltered.length ?
                                <button
                                    onClick={this.handleToggleAll.bind(this)}
                                    type='button'
                                >
                                    <FormattedMessage id={getToggleLabel(this.props.selectedDealers)}/>
                                </button> : null
                        }
                    {this.props.selectedDealers.length > 0 ?
                        <Link to={'/claims/labor-rates/update-labor-rates/multiple'}>
                            <FormattedMessage id='UPDATE_SELECTED'/>
                        </Link> :
                        <button
                            className='button-primary'
                            disabled={true}
                        >
                            <FormattedMessage id='UPDATE_SELECTED'/>
                        </button>
                    }
                </div>
                <section className='main-labor-rate'>
                    <section className='status-indicators'>
                        <LaborRateRequestTypeCount laborRateRequestCount={this.props.laborRateRequestCount}/>
                    </section>
                    <section className='labor-rate-dealers'>
                        <RefinableListWidget
                            onFilterByChange={this.props::handleFilterByChange}
                            onSortByChange={this.props::handleSortByChange}
                            onSortDirectionChange={this.props::handleSortDirectionChange}
                            searchFilters={this.props.searchFilters}
                            sortOptions={sortOptions}
                        />
                        <section className='dealer-list'>
                            {dealerList}
                        </section>
                    </section>
                </section>
            </section>
        );

    }

}

LaborRateDealersList.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    dealersFiltered: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    laborRateRequestCount: PropTypes.instanceOf(LaborRateRequestCount).isRequired,
    queryParams: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};

export default LaborRateDealersList;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/components/index.js